// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product-gallery-container[data-v-a47b69cc]{max-width:660px;width:100%;margin-left:auto;margin-right:auto}.product-content-container[data-v-a47b69cc]{max-width:1110px;margin-left:auto;margin-right:auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
